module.exports = __webpack_public_path__ + "img/圆2.bc023153.svg";